import { Record } from "immutable";
import moment from "moment";

const defaults = {
    _id: undefined,
    __brand: undefined,
    __brand_name: undefined,
    __currency_code: undefined,
    __customer_po_number: undefined,
    __modified_on: undefined,
    __order_number: undefined,
    __ship_start: undefined,
    __status: undefined,
    __total: undefined,
};

export class Order extends Record(defaults) {
    declare _id: string;
    declare __brand: any;
    declare __brand_name: string;
    declare __currency_code: string;
    declare __customer_po_number: string;
    declare __modified_on: moment.Moment;
    declare __order_number: string;
    declare __ship_start: moment.Moment;
    declare __status: string;
    declare __total: number;

    constructor(args) {
        super({
            ...args,
            __modified_on: args.__modified_on ? moment.utc(parseInt(args.__modified_on, 10)) : args.__modified_on,
            __ship_start: args.__ship_start ? moment.utc(parseInt(args.__ship_start, 10)) : args.__ship_start,
        });
    }
}
